import { Modal, Select, Input, Form, message } from "antd";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { UserInfo, FormField, CreateInquiryVM } from "../models/models";
import { createInquiry } from "../models/serverApi";

interface InquiryModalProps {
    open: boolean;
    onClose: () => void;
    formField: FormField;
    formId: number;
    sectionId: number;
    ecrfId: number;
    currentFieldValue?: string;
}

export const InquiryModal: React.FC<InquiryModalProps> = ({
    open, onClose, formField, formId, sectionId, ecrfId, currentFieldValue
}) => {
    const [context] = useContext(AppContext);
    const [form] = Form.useForm();
    const [users, setUsers] = useState<UserInfo[]>([]);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (!open) return;
        fetch("/api/User/All", { headers: { Accept: "application/json" } })
            .then(r => r.json())
            .then((data: UserInfo[]) => {
                setUsers(data.filter(u => u.id !== context.user?.id));
            });
    }, [open]);

    const handleOk = () => {
        form.validateFields().then(async (values) => {
            setSubmitting(true);
            const vm: CreateInquiryVM = {
                toUserId: values.toUserId,
                fieldId: formField.id,
                formId: formId,
                sectionId: sectionId,
                ecrfId: ecrfId,
                patientId: context.selection?.patient?.id ?? 0,
                patientAdmissionId: context.selection?.admission?.id ?? 0,
                note: values.note,
                fieldValueSnapshot: currentFieldValue,
            };
            const result = await createInquiry(vm);
            setSubmitting(false);
            if (result) {
                message.success("Η ερώτηση στάλθηκε");
                form.resetFields();
                onClose();
            } else {
                message.error("Σφάλμα κατά την αποστολή της ερώτησης");
            }
        });
    };

    return (
        <Modal
            open={open}
            title={`Ερώτηση για πεδίο: "${formField.label}"`}
            okText="Αποστολή"
            cancelText="Ακύρωση"
            confirmLoading={submitting}
            onOk={handleOk}
            onCancel={() => { form.resetFields(); onClose(); }}
        >
            {currentFieldValue && (
                <p><strong>Τρέχουσα τιμή:</strong> {currentFieldValue}</p>
            )}
            <Form form={form} layout="vertical">
                <Form.Item
                    name="toUserId"
                    label="Αποστολή σε"
                    rules={[{ required: true, message: "Επιλέξτε παραλήπτη" }]}
                >
                    <Select
                        showSearch
                        placeholder="Επιλέξτε χρήστη"
                        optionFilterProp="label"
                        options={users.map(u => ({
                            value: u.id,
                            label: `${u.firstName} ${u.lastName} (${u.email})`
                        }))}
                    />
                </Form.Item>
                <Form.Item name="note" label="Σημείωση (προαιρετικά)">
                    <Input.TextArea rows={3} maxLength={2000} showCount />
                </Form.Item>
            </Form>
        </Modal>
    );
};
